import fetch from "../fetch";

export default ({ params = {} } = {}) =>
  fetch({ path: `/hy/vehicle-types`, params });
